import React from "react";
import "./style.scss";

const QuantityField = ({ limit = null, product, handleQuantityChange }) => {
  const handleIncrease = () => {
    if(limit && +product.quantity >= limit) return
    handleQuantityChange(+product.quantity + 1)
  };

  const handleDecrease = () => {
    if(+product.quantity < 1) return
    handleQuantityChange(+product.quantity - 1)
  };

  const handleChange = (event) => {
    if (limit && +event.target.value > limit) return;
    handleQuantityChange(event.target.value)
  };



  return (
    <div className="quantity-field">
      <button
        className={`quantity-field__value-button decrease-button ${product?.quantity == 1 ? 'button-disabled' : ''}`}
        disabled={+product?.quantity == 1}
        onClick={handleDecrease}
      >
        <svg
          width="14"
          height="2"
          viewBox="0 0 14 2"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 0H7.77779L6.22221 1.07287e-06L0 0V2H6.22221H7.77779H14V0Z"
            fill="#0F172A"
          />
        </svg>
      </button>
      <input
        className="quantity-field__number"
        type="number"
        value={product?.quantity}
        onChange={handleChange}
        onBlur={e => {
          if(!!!e.target.value || e.target.value == 0){
            handleQuantityChange(1)
          }else
          handleQuantityChange(e.target.value)
        }}
      />
      <button
        className="quantity-field__value-button increase-button"
        onClick={handleIncrease}
      >
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M14 6.22221H7.77779V0H6.22221V6.22221H0V7.77779H6.22221V14H7.77779V7.77779H14V6.22221Z"
            fill="#0F172A"
          />
        </svg>
      </button>
    </div>
  );
};

export default QuantityField;
